import { cmsWebComponentsMap } from '@ui/webComponentExports';
import { GeneratedColumn, GeneratedRow } from './contracts';
import { ColumnAlignment, ColumnDirection } from '@repo/types';

export default function Row({ id, tree }: GeneratedRow) {
  return (
    <div className="slc-row">
      {tree.rows[id]!.columnIds.map((columnId) => (
        <Column key={columnId} id={columnId} tree={tree} />
      ))}
    </div>
  );
}

function Column({ id, tree }: GeneratedColumn) {
  const column = tree.columns[id]!;
  const direction = column.direction ?? ColumnDirection.Bottom;
  const alignment = column.alignment ?? ColumnAlignment.Center;

  let justifyContent = 'center';
  if (alignment === ColumnAlignment.Left) {
    justifyContent = 'flex-start';
  } else if (alignment === ColumnAlignment.Right) {
    justifyContent = 'flex-end';
  }

  return (
    <div
      key={id}
      className="slc-column"
      style={{
        gridColumn: `span ${column.size}`,
        flexDirection: direction === ColumnDirection.Bottom ? 'column' : 'row',
        justifyContent,
        alignItems: direction === ColumnDirection.Bottom ? justifyContent : 'center',
      }}
    >
      {column.childrenIds.map((childId) => {
        if (tree.components[childId]) {
          const componentData = tree.components[childId];
          if (!componentData) {
            return null;
          }
          // @ts-expect-error TODO: fix this
          const Component = cmsWebComponentsMap[componentData.type];
          const props = {
            ...componentData,
            ...(componentData.data ?? {}),
          };

          // @ts-ignore
          return <Component key={childId} {...(props as any)} />;
        } else if (tree.rows[childId]) {
          return <Row key={childId} id={childId} tree={tree} />;
        }
      })}
    </div>
  );
}
